module.exports = __webpack_public_path__ + "static/media/teacher-male-asian.d2e3377a.png";